export default __webpack_public_path__ + "static/media/309.489da814.png";